export const icons = [
  {
    key: 'home',
    path: 'assets/icons/home.svg'
  },
  {
    key: 'academic',
    path: 'assets/icons/academic.svg'
  },
  {
    key: 'payment',
    path: 'assets/icons/payment.svg'
  },
  {
    key: 'procedures',
    path: 'assets/icons/procedures.svg'
  },
  {
    key: 'career',
    path: 'assets/icons/career.svg'
  },
  {
    key: 'student',
    path: 'assets/icons/student.svg'
  },
  {
    key: 'process',
    path: 'assets/icons/process.svg'
  },
  {
    key: 'info',
    path: 'assets/icons/info.svg'
  },
  {
    key: 'bell',
    path: 'assets/icons/bell.svg'
  },
  {
    key: 'bell-point',
    path: 'assets/icons/bell-point.svg'
  },
  {
    key: 'search',
    path: 'assets/icons/search.svg'
  },
  {
    key: 'arrow-down',
    path: 'assets/icons/arrow-down.svg'
  },
  {
    key: 'arrow-up',
    path: 'assets/icons/arrow-up.svg'
  },
  {
    key: 'arrow-left',
    path: 'assets/icons/arrow-left.svg'
  },
  {
    key: 'dropdown-arrow',
    path: 'assets/icons/dropdown-arrow.svg'
  },
  {
    key: 'arrow-down-2',
    path: 'assets/icons/arrow-down-2.svg'
  },
  {
    key: 'arrow-up-2',
    path: 'assets/icons/arrow-up-2.svg'
  },
  {
    key: 'menu',
    path: 'assets/icons/menu.svg'
  },
  {
    key: 'close',
    path: 'assets/icons/close.svg'
  },
  {
    key: 'registration',
    path: 'assets/icons/registration.svg'
  },
  {
    key: 'grades',
    path: 'assets/icons/grades.svg'
  },
  {
    key: 'recently-accepted',
    path: 'assets/icons/recently-accepted.svg'
  },
  {
    key: 'show-more',
    path: 'assets/icons/show-more.svg'
  },
  {
    key: 'dots',
    path: 'assets/icons/dots.svg'
  },
  {
    key: 'plus',
    path: 'assets/icons/plus.svg'
  },
  {
    key: 'minus',
    path: 'assets/icons/minus.svg'
  },
  {
    key: 'plus-2',
    path: 'assets/icons/plus-2.svg'
  },
  {
    key: 'minus-2',
    path: 'assets/icons/minus-2.svg'
  },
  {
    key: 'plus-3',
    path: 'assets/icons/plus-3.svg'
  },
  {
    key: 'minus-3',
    path: 'assets/icons/minus-3.svg'
  },
  {
    key: 'exams',
    path: 'assets/icons/exams.svg'
  },
  {
    key: 'next',
    path: 'assets/icons/next.svg'
  },
  {
    key: 'next-2',
    path: 'assets/icons/next-2.svg'
  },
  {
    key: 'prev',
    path: 'assets/icons/prev.svg'
  },
  {
    key: 'prev-2',
    path: 'assets/icons/prev-2.svg'
  },
  {
    key: 'clock',
    path: 'assets/icons/clock.svg'
  },
  {
    key: 'location',
    path: 'assets/icons/location.svg'
  },
  {
    key: 'location-2',
    path: 'assets/icons/location-2.svg'
  },
  {
    key: 'info-2',
    path: 'assets/icons/info-2.svg'
  },
  {
    key: 'print',
    path: 'assets/icons/print.svg'
  },
  {
    key: 'alert',
    path: 'assets/icons/alert.svg'
  },
  {
    key: 'courses',
    path: 'assets/icons/courses.svg'
  },
  {
    key: 'download',
    path: 'assets/icons/download.svg'
  },
  {
    key: 'calendar',
    path: 'assets/icons/calendar.svg'
  },
  {
    key: 'calendar-current',
    path: 'assets/icons/calendar-current.svg'
  },
  {
    key: 'calendar-current-point',
    path: 'assets/icons/calendar-current-point.svg'
  },
  {
    key: 'schedule',
    path: 'assets/icons/schedule.svg'
  },
  {
    key: 'message',
    path: 'assets/icons/message.svg'
  },
  {
    key: 'recent-message',
    path: 'assets/icons/recent-message.svg'
  },
  {
    key: 'billing',
    path: 'assets/icons/billing.svg'
  },
  {
    key: 'check',
    path: 'assets/icons/check.svg'
  },
  {
    key: 'operation-salary',
    path: 'assets/icons/operation-salary.svg'
  },
  {
    key: 'operation-pay',
    path: 'assets/icons/operation-pay.svg'
  },
  {
    key: 'operation-refunds',
    path: 'assets/icons/operation-refunds.svg'
  },
  {
    key: 'dean',
    path: 'assets/icons/dean.svg'
  },
  {
    key: 'play',
    path: 'assets/icons/play.svg'
  },
  {
    key: 'collaboration',
    path: 'assets/icons/collaboration.svg'
  },
  {
    key: 'assistance-support',
    path: 'assets/icons/assistance-support.svg'
  },
  {
    key: 'consultation',
    path: 'assets/icons/consultation.svg'
  },
  {
    key: 'social-involvement',
    path: 'assets/icons/social-involvement.svg'
  },
  {
    key: 'career-1',
    path: 'assets/icons/career-1.svg'
  },
  {
    key: 'career-2',
    path: 'assets/icons/career-2.svg'
  },
  {
    key: 'career-3',
    path: 'assets/icons/career-3.svg'
  },
  {
    key: 'career-4',
    path: 'assets/icons/career-4.svg'
  },
  {
    key: 'career-5',
    path: 'assets/icons/career-5.svg'
  },
  {
    key: 'video',
    path: 'assets/icons/video.svg'
  },
  {
    key: 'empty',
    path: 'assets/icons/empty.svg'
  }
];
